import { ArgoCDAnnotationKeys } from "@octopusdeploy/octopus-server-client";
export function createHelmImageAnnotations(templateExpressionMap: Record<string, string | undefined>): string {
    return Object.entries(templateExpressionMap)
        .map(([key, value]) => `${ArgoCDAnnotationKeys.HelmImageReplacePathPrefix}.${key}: "${value || ""}"`)
        .join("\n");
}
